export const PREV_MENU_ANALYSIS_ACTION_START = 'PREV_MENU_ANALYSIS_ACTION_START';
export const PREV_MENU_ANALYSIS_ACTION_ERROR = 'PREV_MENU_ANALYSIS_ACTION_ERROR';
export const PREV_MENU_ANALYSIS_CLONE_SUCCESS = 'PREV_MENU_ANALYSIS_CLONE_SUCCESS';
export const PREV_MENU_ANALYSIS_UPDATE_VALUE_SUCCESS = 'PREV_MENU_ANALYSIS_UPDATE_VALUE_SUCCESS';
export const PREV_MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS = 'PREV_MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS';
export const PREV_MENU_CATEGORIES_ANALYSIS_UPDATE_VALUE_SUCCESS = 'PREV_MENU_CATEGORIES_ANALYSIS_UPDATE_VALUE_SUCCESS';
export const PREV_MENU_ANALYSIS_RESET_STATE = 'PREV_MENU_ANALYSIS_RESET_STATE';

export function clonePrevMenuAnalysis(data) {
  return {
    type: PREV_MENU_ANALYSIS_CLONE_SUCCESS,
    data,
  };
}

export function updatePrevMenuAnalysis(key, value) {
  return {
    type: PREV_MENU_ANALYSIS_UPDATE_VALUE_SUCCESS,
    key,
    value,
  };
}

export function updatePrevMenuItemsAnalysis(categoryId, menuItemId, key, value) {
  return {
    type: PREV_MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS,
    categoryId,
    menuItemId,
    key,
    value,
  };
}

export function updatePrevMenuCategoriesAnalysis(categoryId, key, value) {
  return {
    type: PREV_MENU_CATEGORIES_ANALYSIS_UPDATE_VALUE_SUCCESS,
    categoryId,
    key,
    value,
  };
}

export function resetprevMenuAnalysisState() {
  return {
    type: PREV_MENU_ANALYSIS_RESET_STATE,
  };
}

export function getPrevMenuAnalysis() {
  return (dispatch, getState) => {
    return getState().prevMenuAnalysis.get('data');
  };
}
